<template>
  <div class="mt-8 flex flex-col px-5 text-sm">
    <div
      class="justify-between py-4 rounded-md border w-full mt-6 p-6 bg-indigo-600 text-white"
    >
      <div class="flex gap-7 justify-center text-center">
        <h3 class="text-white py-5">
          Unlock the viral tiktok ads of this month
        </h3>
      </div>

      <div class="flex justify-center text-center">
        <router-link to="/pricing">
          <Button
            type="submit"
            class="px-2 py-0 bg-green-500 hover:bg-indigo-400 text-indigo-600 rounded-md"
          >
            <div class="rounded py-0 my-0 mr-2">
              <Icon name="LockOpen" class="w-6 h-6" />
            </div>
            <div class="mt-2 py-0">
              Unlock now
            </div>
          </Button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import Button from "@/components/UI/Button";
import Icon from "@/components/UI/Icon";

export default {
  components: { Icon, Button },
  setup() {
    const store = useStore();

    const loading = ref(false);

    const role = computed(() => store.state.role);

    return { role, loading };
  },
};
</script>

<style>
.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 9px;
  margin: 7.2px 0;
}
.lds-ellipsis div {
  position: absolute;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #fff;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 6px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 6px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 24px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 42px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(18px, 0);
  }
}
</style>
